<template>
  <div>
    <template v-if="!keinGueltigerFragebogen">
      <FragebogenHeader :projekt="projekt ? projekt : null" />
      <v-row v-if="fragebogenlokal.zwischenstand.kommentar">
        <v-col>
          <h3>Anmerkungen zum Fragebogen:</h3>
          <p>{{ fragebogenlokal.zwischenstand.kommentar }}</p>
        </v-col>
      </v-row>
      <b-unit no-header>
        <v-tabs content-class="mt-3">
          <v-tab
            v-for="(abschnitt, abschnitt_index) in fragebogenlokal.zwischenstand
            .abschnitte" :key="abschnitt_index"
          >
            {{ 1 + abschnitt_index }}) {{ abschnitt.abschnittname }}
          </v-tab>
            <v-tab-item v-for="(abschnitt, abschnitt_index) in fragebogenlokal.zwischenstand.abschnitte" :key="abschnitt_index">
            <div class="fragebogenAbschnitt" >
              <v-row v-if="abschnitt.kommentar">
                <v-col>
                  <h4>Anmerkungen zu Abschnitt {{ 1 + abschnitt_index }}) {{ abschnitt.abschnittname }}:</h4>
                  <p>{{ abschnitt.kommentar }}</p>
                </v-col>
              </v-row>
              <template v-for="(frage, frage_index) in abschnitt.fragen">
                <div
                    class="frage"
                    :key="abschnitt_index + '.' + frage_index + ' fragestellung'"
                >
                  <v-row>
                    <v-col>
                      <h4>
                        {{ 1 + abschnitt_index }}.{{ 1 + frage_index }})
                        {{ frage.fragestellung }}
                      </h4>
                    </v-col>
                  </v-row>
                  <v-row :key="abschnitt_index + '.' + frage_index + ' tabelle'">
                    <v-col cols="12">
                      <b-data-table
                          bordered
                          :headers="
                        ueberschriftenVorbereiten(frage.tabelle.spaltenNamen)
                      "
                          :items="
                        frage.tabelle.einträge ? frage.tabelle.einträge : []
                      "
                          :item-class="setCustomClass"
                      >
                        <template #[`item.kommentar`]="{ item }">
                          <div v-if="item.kommentar">
                            {{ item.kommentar }}
                            <v-icon
                                small
                                :disabled="!zwischenstandAktuell"
                                @click="
                              kommentarBearbeiten(
                                item,
                                abschnitt_index,
                                frage_index
                              )
                            "
                            >mdi-pencil</v-icon
                            >
                          </div>
                          <div v-else>
                            <b-btn
                                :disabled="!zwischenstandAktuell"
                                @click="
                              kommentarBearbeiten(
                                item,
                                abschnitt_index,
                                frage_index
                              )
                            "
                            >
                              Kommentar hinzufügen
                            </b-btn>
                          </div>
                        </template>
                        <template #[`item.aktionen`]="{ item }">
                          <v-icon
                              small
                              :disabled="item.ausgegraut === 'true'"
                              @click="
                            antwortBearbeiten(item, abschnitt_index, frage_index)
                          "
                          >mdi-pencil</v-icon
                          >
                          <v-icon
                              :disabled="item.ausgegraut == 'true'"
                              small
                              @click="
                            loeschenPopupOeffnen(
                              item,
                              abschnitt_index,
                              frage_index
                            )
                          "
                          >mdi-delete</v-icon
                          >
                        </template>
                      </b-data-table>
                    </v-col>
                  </v-row>
                  <v-row
                      v-if="bearbeitbar"
                      :key="abschnitt_index + '.' + frage_index + ' button'"
                  >
                    <v-col cols="12">
                      <v-btn
                          text
                          class="button"
                          color="blue"
                          x-large
                          @click="neueAntwort(abschnitt_index, frage_index)"
                      >
                        <v-icon class="mr-3">mdi-plus-circle</v-icon> Neuen Eintrag hinzufügen
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </template>
            </div>
          </v-tab-item>
        </v-tabs>
        <template v-if="fragebogenlokal.zwischenstand.box != null">
          <v-row>
            <v-checkbox
                :label="fragebogenlokal.zwischenstand.box.boxText"
                v-model="fragebogenlokal.zwischenstand.box.ausgewaehlt"
                :disabled="!bearbeitbar"
            ></v-checkbox>
          </v-row>
        </template>
      </b-unit>
    </template>

    <FragebogenAntwortPopup
      v-if="openPopup"
      @close="popupsSchilessen()"
      @save="
        antwortHinzufügen(
          fragebogenlokal.zwischenstand.abschnitte[gewaehlterAbschnittIndex]
            .fragen[gewaehlteFrageIndex].tabelle,
          $event
        )
      "
      :ueberschriften="
        ueberschriftenVorbereiten(
          fragebogenlokal.zwischenstand.abschnitte[gewaehlterAbschnittIndex]
            .fragen[gewaehlteFrageIndex].tabelle.spaltenNamen
        )
      "
      :antwort="ausgewaehlteAntwort"
    />
    <LoeschenPopup
      v-if="zeigeLoeschenPopup"
      text="Wollen Sie die Antwort wirklich löschen?"
      @cancel="zeigeLoeschenPopup = false"
      @delete="antwortLoeschen()"
    />
    <KommentarPopup
      v-if="zeigeKommentarPopup"
      @close="popupsSchilessen()"
      @save="
        kommentarBearbeiten(
          fragebogenlokal.zwischenstand.abschnitte[gewaehlterAbschnittIndex]
            .fragen[gewaehlteFrageIndex].tabelle,
          $event
        )
      "
      :antwort="ausgewaehlteAntwort"
    />
  </div>
</template>

<script>
import FragebogenAntwortPopup from '@/components/popups/FragebogenAntwortPopup';
import LoeschenPopup from '@/components/popups/LoeschenPopup';
import KommentarPopup from '@/components/popups/KommentarPopup';
import FragebogenHeader from '@/views/fragebogen/FragebogenHeader';
import dataMixin from '@/mixins/data-mixin';
import axios from 'axios';
import _ from 'lodash';

export default {
  name: 'FragebogenModule',
  components: {
    FragebogenAntwortPopup,
    FragebogenHeader,
    LoeschenPopup,
    KommentarPopup,
  },
  props: {
    fragebogenIdentifier: {
      type: Object,
      reqired: true,
    },
    fragebogenVorherGeladen: {
      type: Boolean,
      default: false,
    },
    zwischenstandAktuell: {
      type: Boolean,
      default: false,
    },
    ausfuellerSicht: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      openPopup: false,
      zeigeLoeschenPopup: false,
      zeigeKommentarPopup: false,
      ausgewaehlteAntwort: {},
      gewaehlteFrageIndex: undefined,
      gewaehlterAbschnittIndex: undefined,
      neueAntwortErstellt: false,
      fragebogenlokal: { zwischenstand: {} },
      checkboxDummy: false,
      aktuelleFrage: {},
      keinGueltigerFragebogen: false,
      projekt: undefined,
    };
  },
  created: function () {
    this.ladeFragebogen();
  },
  watch: {
    fragebogenlokal: {
      handler: function (newVal) {
        this.fragebogen = _.cloneDeep(newVal);
      },
      deep: true,
    },
  },
  computed: {
    bearbeitbar() {
      return (
        this.$router.currentRoute.name == 'fragebogenAusfuellen' ||
        (this.$router.currentRoute.name ==
          'fragebogenZwischenstandUebersicht' &&
          this.zwischenstandAktuell)
      );
    },
  },
  mixins: [dataMixin('fragebogen', 'loadedData.fragebogen')],
  methods: {
    ladeFragebogen() {
      if (!this.fragebogenVorherGeladen) {
        this.fragebogenVorherGeladen = false;
        axios
          .get(`/v1/${this.fragebogenIdentifier.typ}`, {
            params: this.fragebogenIdentifier.parameter,
          })
          .then((response) => {
            if (this.ausfuellerSicht) {
              this.fragebogenlokal = _.cloneDeep(response.data.fragebogen);
              this.projekt = response.data.projekt;
            } else {
              this.fragebogenlokal = _.cloneDeep(response.data);
              this.ladeProjekt(response.data.projektId);
            }
          })
          .catch(() => {
            this.keinGueltigerFragebogen = true;
            this.$emit('error');
          });
      } else {
        this.fragebogenlokal = _.cloneDeep(this.fragebogenIdentifier);
      }
    },
    ladeProjekt(projektId) {
      axios.get(`/v1/projekt/${projektId}`).then((response) => {
        this.projekt = response.data;
      });
    },
    neuLaden() {
      this.fragebogenlokal = _.cloneDeep(this.fragebogen);
    },
    popupsSchilessen() {
      this.ausgewaehlteAntwort = {};
      this.neueAntwortErstellt = false;
      this.gewaehlteFrageIndex = undefined;
      this.gewaehlterAbschnittIndex = undefined;
      this.openPopup = false;
      this.zeigeKommentarPopup = false;
    },
    antwortPopupOeffnen(abschnitt_index, frage_index) {
      if (this.bearbeitbar) {
        this.gewaehlterAbschnittIndex = abschnitt_index;
        this.gewaehlteFrageIndex = frage_index;
        this.openPopup = true;
      }
    },
    loeschenPopupOeffnen(item, abschnitt_index, frage_index) {
      this.aktuelleFrage = {
        item: item,
        abschnitt_index: abschnitt_index,
        frage_index: frage_index,
      };
      this.zeigeLoeschenPopup = true;
    },
    kommentarBearbeiten(item, abschnitt_index, frage_index) {
      this.ausgewaehlteAntwort = item;
      this.kommentarantwortPopupOeffnen(abschnitt_index, frage_index);
    },
    antwortBearbeiten(item, abschnitt_index, frage_index) {
      this.ausgewaehlteAntwort = item;
      this.antwortPopupOeffnen(abschnitt_index, frage_index);
    },
    antwortLoeschen() {
      const item = this.aktuelleFrage.item;
      const abschnitt_index = this.aktuelleFrage.abschnitt_index;
      const frage_index = this.aktuelleFrage.frage_index;
      let item_index = this.fragebogenlokal.zwischenstand.abschnitte[
        abschnitt_index
      ].fragen[frage_index].tabelle.einträge.findIndex(
        (element) => element === item
      );
      this.fragebogenlokal.zwischenstand.abschnitte[abschnitt_index].fragen[
        frage_index
      ].tabelle.einträge.splice(item_index, 1);
      this.zeigeLoeschenPopup = false;
    },
    antwortHinzufügen(tabelle, antwort) {
      if (tabelle.einträge == null) tabelle.einträge = [];
      if (this.neueAntwortErstellt) {
        tabelle.einträge.push(antwort);
        this.neueAntwortErstellt = false;
      }
    },
    neueAntwort(abschnitt_index, frage_index) {
      this.neueAntwortErstellt = true;
      this.antwortPopupOeffnen(abschnitt_index, frage_index);
    },
    ueberschriftenVorbereiten(spaltenNamen) {
      let ueberschriften = [...spaltenNamen];
      ueberschriften.push({
        text: 'Bearbeiten / Löschen',
        value: 'aktionen',
        sortable: false,
      });

      if (
        this.$router.currentRoute.name != 'fragebogenZwischenstandUebersicht'
      ) {
        ueberschriften = ueberschriften.filter(
          (item) => item.value != 'kommentar'
        );
      }
      return ueberschriften;
    },
    setCustomClass(item) {
      if (
        this.$router.currentRoute.name == 'fragebogenZwischenstandUebersicht'
      ) {
        return '';
      }
      const rowClass = item.ausgegraut == 'true' ? 'ausgegraut' : '';
      return rowClass;
    },
    kommentarantwortPopupOeffnen(abschnitt_index, frage_index) {
      this.gewaehlterAbschnittIndex = abschnitt_index;
      this.gewaehlteFrageIndex = frage_index;
      this.zeigeKommentarPopup = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.ausgegraut {
  opacity: 0.6;
}
.nicht-ausgegraut {
  opacity: 0.6;
}

.v-tab {
  font-size: 14px;
}

.fragebogenAbschnitt {
  margin-bottom: 20px;
  .frage {
    margin-bottom: 20px;
    h4 {
      word-break: break-all;
    }
    .button {
      text-transform: none;
      padding: 0 0 0 10px;
      height: 30px;
    }
  }
}
</style>